import React, { useEffect, useState } from "react";
import InstaFeeds from "./InstaComponent/InstaFeeds";
import background from "./pink.jpg";
import { ins_url } from "../../fresha_url";

const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(window.matchMedia(query).matches);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) setMatches(media.matches);
    const listener = () => setMatches(media.matches);
    media.addListener(listener);
    return () => media.removeListener(listener);
  }, [matches, query]);

  return matches;
};

const Instagram = () => {
  const isDesktop = useMediaQuery("(min-width: 1024px)"); // desktop breakpoint
  const limit = isDesktop ? 12 : 4;
  return (
    <div
      id="instagram"
      style={{
        // backgroundImage: `url(${background})`,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        background: "radial-gradient(circle at top left, #F3ADB8, #F9D3D8)",
      }}
    >
      <h1 className="instagram-title">Follow us on Instagram</h1>
      <a
        href={ins_url}
        target="_blank"
        style={{
          fontSize: "1.5rem",
          fontWeight: 600,
          marginBottom: "2rem",
          textDecoration: "none",
          color: "#fe036a",
        }}
      >
        #nelsonlashandbrows
      </a>

      <InstaFeeds
        token="IGAATTmU051clBZAFFZASVNUeEtLY3NMZA0hFMm5GMHRUb1RsYVRaUHYxMVI0ZA0t6cnZAmdVZAVazZA5bVJiangySk45emlSOWUtclRhanE4TTNfX25MU0dTdU8ySE5KMHRQNU80M2dHd0ZA6b09sbFI0Y3hZALUZAJVEZAReGU1eGVXXzhLawZDZD"
        // token="IGAATTmU051clBZAE1DbG5JWVROOHJqM1dHRUM2WE1YeFFFLWpVS3k0QWtDS1BHanA0MHVIWGx3dnpqYXBuUGJEMlJrRXg0V0s1U0ZAVYjduc2FCcjgwRWtFa1ZApOWYwcExCV1MzTmdTYVpXZAGJPa1ZAqUUdWdE9lcTdZASUZAJbUdWNAZDZD"
        limit={limit}
      />
    </div>
  );
};

export default Instagram;
